import { Tooltip } from '@chakra-ui/react';
import { type FC, type JSX } from 'react';

export interface ActionBarTooltipProps {
  children: JSX.Element;
  label: string;
}

export const ActionBarTooltip: FC<ActionBarTooltipProps> = ({
  children,
  label,
}) => {
  return (
    <Tooltip
      fontSize='xs'
      border='1px solid'
      borderColor='border'
      borderRadius='2px'
      label={label}
    >
      {children}
    </Tooltip>
  );
};
